import { Order } from '../types';

const PRE_DISPATCH_STATUSES = new Set<Order['status']>([
  'pending',
  'waiting_confirmation',
  'scheduled_confirmed',
  'payment_pending',
  'scheduled',
  'confirmed',
  'ready'
]);

const DRIVER_ROUTE_ACTIVE_STATUSES = new Set<Order['status']>(['assigned', 'dispatched']);

const DRIVER_LINK_CLEAR_STATUSES = new Set<Order['status']>(['delivered', 'canceled', 'archived']);

export const shouldClearDriverLinkForStatus = (status: Order['status']): boolean => {
  return DRIVER_LINK_CLEAR_STATUSES.has(status);
};

export const resolveSyncedOrderStatus = (
  current: Pick<Order, 'status' | 'driverId'>,
  incomingStatus: Order['status']
): Order['status'] => {
  if (current.status === 'ready' && incomingStatus === 'confirmed') {
    return 'ready';
  }

  const shouldPreserveRouteStatus = Boolean(current.driverId) &&
    DRIVER_ROUTE_ACTIVE_STATUSES.has(current.status) &&
    (
      PRE_DISPATCH_STATUSES.has(incomingStatus) ||
      (current.status === 'dispatched' && incomingStatus === 'assigned')
    );

  if (shouldPreserveRouteStatus) {
    return current.status;
  }

  return incomingStatus;
};

export const resolveSyncedPickupConfirmed = (
  current: Pick<Order, 'status' | 'pickupConfirmed'>,
  incoming: Pick<Order, 'pickupConfirmed'>,
  finalStatus: Order['status']
): boolean => {
  if (shouldClearDriverLinkForStatus(finalStatus)) {
    return false;
  }

  if (current.status === 'dispatched' && current.pickupConfirmed && finalStatus === 'dispatched') {
    return true;
  }

  return incoming.pickupConfirmed ?? current.pickupConfirmed ?? false;
};
